import { inject, Injectable } from '@angular/core';
import { AppEnvironment, EnvironmentApiConfig } from '@core/api/api.abstraction';
import { AuthService } from '@core/auth';
import { AppLicense } from '@core/licenses';
import { API_URL_CONFIG } from '@root/api-url.config';
import { decodeJwt } from '@shared/utils';

const LICENSE_URL_INDEX = 2;

@Injectable({
  providedIn: 'root',
})
export class ApiUrlResolver {
  public getConfig(): EnvironmentApiConfig {
    const authService = inject(AuthService);

    const accessToken = decodeJwt<{ groups: string[] }>(
      authService.getAccessToken() ?? '',
      window,
    );

    const currentGroup = (accessToken.groups || [])
      .find(group => group.includes(this.getLicenseFromUrl(location.pathname)));

    const isInternalDev = (accessToken.groups || [])
      .some(group => group.includes('chatbots.dev'));

    if (isInternalDev) {
      return {
        apiHost: 'https://api-dev.pin-up-chatbots.com/api/v1',
        grpcHost: 'https://api-grpc-dev.pin-up-chatbots.com',
      };
    }

    if (!currentGroup) {
      // console.log('should be logouted');
      // this.authService.logout();

      const currentEnv = (accessToken.groups || [])[0]?.split('.').at(2) as AppEnvironment;
      const envConfig = API_URL_CONFIG[currentEnv];
      return envConfig[this.getLicenseFromUrl(location.pathname)];
    }

    const [type, license, env] = currentGroup.split('.');
    const envConfig = API_URL_CONFIG[env as AppEnvironment];
    return envConfig[license as AppLicense];
  }

  private getLicenseFromUrl(url: string): AppLicense {
    if (!url) {
      return null;
    }
    return url.split('/').at(LICENSE_URL_INDEX) as AppLicense
  }
}